import React from 'react';
import {Form, Select} from 'semantic-ui-react';
import {orderTypes, transportTypes} from '../../constants';
import {parseProviders} from '../../../common/util/options';

const FilterForm = ({
  handleChange,
  providers,
  transport,
  orderType,
  provider,
  disabled,
}) => {
  const providersOptions = parseProviders(providers);

  return (
    <React.Fragment>
      <Form.Field
        name='provider'
        label='Proveedor'
        placeholder='Seleccione Proveedor'
        control={Select}
        options={providersOptions}
        value={provider}
        onChange={handleChange}
        disabled={disabled}
      />
      <Form.Field
        name='transport'
        label='Transporte'
        placeholder='Seleccione Transporte'
        control={Select}
        options={transportTypes}
        value={transport}
        onChange={handleChange}
        disabled={disabled}
      />
      <Form.Field
        name='orderType'
        label='Tipo de repuesto'
        placeholder='Seleccione tipo de repuesto'
        control={Select}
        options={orderTypes}
        value={orderType}
        onChange={handleChange}
        disabled={disabled}
      />
    </React.Fragment>
  );
};

export default FilterForm;
